import { useCurrentCampagne } from "@common/hooks/campagne";
import {
  CampagneProjection,
  OrganismeInscriptionDto, OrganismeStatutType, useGetCampagneByAnneeQuery,
  useLazyGetExtOrganismeQuery, useLazyGetOrganismeForCampagneQuery,
} from '@common/services';
import { useAppDispatch } from '../../../hooks/store.hook';
import {
  resetInscription,
  setOrganismeInfo,
  setRequested,
} from '../../../stores/inscription.slice';

export function useSearchOrganismeBySiren() {
  const dispatch = useAppDispatch();

  const { campagne } = useCurrentCampagne();
  const { data: campagnePrecedente } = useGetCampagneByAnneeQuery(
      { year: (campagne?.annee ?? 0) - 1, projection: CampagneProjection.ANNEE },
      { skip: !campagne?.annee },
  );

  const [getOrganismeByCampagne] = useLazyGetOrganismeForCampagneQuery();
  const [getExtOrganisme] = useLazyGetExtOrganismeQuery();

  return {
    getOrganismeBySiren: async (siren: string) => {
      // On vide l'inscription avant de récupérer un nouvel organisme
      dispatch(resetInscription());

      // On cherche d'abord sur la campagne COURANTE
      const organismeCourant: OrganismeInscriptionDto | null = campagne?.id
          ? await getOrganismeByCampagne({ siren, campagneId: campagne.id })
              .unwrap()
              .catch(() => null)
          : null;

      // Si trouvé sur la campagne courante et que ce n'est pas un refus
      if (organismeCourant && organismeCourant.statut !== OrganismeStatutType.REFUS) {
        dispatch(setOrganismeInfo(organismeCourant));
        return;
      }

      // Sinon, on cherche sur la campagne PRÉCÉDENTE pour pré-remplissage
      const organismePrecedent: OrganismeInscriptionDto | null = campagnePrecedente?.id
        ? await getOrganismeByCampagne({ siren, campagneId: campagnePrecedente.id })
              .unwrap()
              .catch(() => null)
          : null;

      if (organismePrecedent) {
        dispatch(setOrganismeInfo(organismePrecedent));
        return;
      }

      // Si rien n'est trouvé et que c'était un refus, on le remonte
      if (organismeCourant) {
        dispatch(setOrganismeInfo(organismeCourant));
        return;
      }

      // Si l'Organisme n'est pas trouvée côté DB MAP, on le récupère côté Karoussel/Rule
      const extOrganisme: OrganismeInscriptionDto | null = await getExtOrganisme({ siren }).unwrap().catch(() => null);
      if (extOrganisme) {
        dispatch(setOrganismeInfo(extOrganisme));
        return;
      }

      dispatch(setRequested(true));
    },
  };
}